// Hamburger menu
let hamburger = document.querySelector('.hamburger');
let menu = document.querySelector('.list__btn');

function showMenu () {
  hamburger.classList.toggle('hamburger__active');
  menu.classList.toggle('list__btn--active');
}

// Copyright
let date = new Date();
document.querySelector('.footer__copyright p span').textContent = date.getFullYear();

// WOW Animation
let wow = new WOW(
    {
      boxClass:     'wow',
      animateClass: 'animate__animated',
      mobile: false
    }
);
wow.init();

//Video youtube
function r(f) {
  /in/.test(document.readyState) ? setTimeout('r(' + f + ')', 9) : f();
}

r(function () {
  // Получаем все видео
  var videos = document.getElementsByClassName ? document.getElementsByClassName("youtube") : (function(node, classname){
    var a = [];
    var re = new RegExp('(^| )' + classname + '( |$)');
    var els = node.getElementsByTagName("*");
    for (var i=0; i<els.length; i++) if(re.test(els[i].className)) a.push(els[i]);
    return a;
  })(document.body, "youtube");

  Array.prototype.forEach.call(videos, function(video){
    // Берем fallback или стандартное hq превью
    var fallback = video.getAttribute('data-fallback') || 'https://img.youtube.com/vi/' + video.id + '/hqdefault.jpg';

    // Сразу ставим фон
    video.style.backgroundImage = 'url(' + fallback + ')';

    // Создаем кнопку Play
    var playBtn = document.createElement('div');
    playBtn.className = 'about_brand__video--play';
    playBtn.innerHTML = `<svg class="icon"><use xlink:href="./img/sprite.svg#icon-play"></use></svg>`;
    playBtn.style.position = 'absolute';
    playBtn.style.top = '50%';
    playBtn.style.left = '50%';
    playBtn.style.transform = 'translate(-50%, -50%)';
    playBtn.style.pointerEvents = 'none'; // чтобы клик проходил через кнопку
    video.appendChild(playBtn);

    // Клик по видео
    video.addEventListener('click', function () {
      var iframe = document.createElement("iframe");
      var iframe_url = "https://www.youtube.com/embed/" + this.id + "?autoplay=1&autohide=1";
      if (this.getAttribute("data-params")) iframe_url += '&' + this.getAttribute("data-params");
      iframe.setAttribute("src", iframe_url);
      iframe.setAttribute("class", 'youtube');
      iframe.setAttribute("frameborder", '0');
      iframe.setAttribute("allowfullscreen", '');
      iframe.setAttribute("allow", 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      this.parentNode.replaceChild(iframe, this);
    });
  });
});

$slider = document.querySelector('.slider');
if($slider) {
  const swiper = new Swiper($slider, {
    centeredSlides: true,
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
  });
}
